import { connect } from 'react-redux';
import styled from 'styled-components';
import { filterFieldsType } from '../../../../../state/ducks/allShipmentsPage/allShipmentsPage';
import { settings } from '../../../../../models/entities/shipment/shipment';
import { shipmentsSelectors } from '../../../../../state/ducks/shipments/selectors';
import { RootState } from '../../../../../state/store/store';
import { parseConsolidationFilterFields } from './consolidationsFilterUtils';
import { parsedFilterFieldType, removeFilterItem } from '../../utils';

type Props = {
    filterFields: filterFieldsType;
    setFilterFields: (filter: filterFieldsType) => void;
    settings: settings;
    localization: any;
};

const ConsolidationsFiltersStripe = ({ filterFields, setFilterFields, settings, localization }: Props) => {
    const parsedFilters = parseConsolidationFilterFields(filterFields, [], settings, localization, [], []);

    return (
        <FiltersStripeContainer>
            {parsedFilters.map((filter: parsedFilterFieldType, i) => (
                <FilterBadge key={i}>
                    {filter.parsedValue}
                    <FilterRemove
                        className="material-icons"
                        onClick={() => setFilterFields(removeFilterItem(filter, filterFields))}
                    >
                        close
                    </FilterRemove>
                </FilterBadge>
            ))}
        </FiltersStripeContainer>
    );
};

const FiltersStripeContainer = styled.div`
    flex: 1;
    font-size: 12px;
    display: flex;
    overflow-x: hidden;

    @media screen and (max-width: 768px) {
        display: none;
    }

    &:hover {
        overflow-x: overlay;
    }

    &::-webkit-scrollbar {
        height: 2px;
    }

    &::-webkit-scrollbar-track {
        background-color: white;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
    }
`;

const FilterBadge = styled.span`
    border-radius: 2vh;
    border: 1px solid #008ac9;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    height: 24px;
    padding: 3px 8px;
    margin-left: 10px;
    display: inline-flex;
    align-items: center;
    line-height: 1px;
    min-width: max-content;
`;

const FilterRemove = styled.span`
    font-size: 12px;
    color: #008ac9;
    margin-left: 5px;
    cursor: pointer;
`;

const mapStateToProps = (state: RootState) => ({
    settings: shipmentsSelectors.settingsByLanguage(state)()
});

export default connect(mapStateToProps)(ConsolidationsFiltersStripe);
